import PropTypes from 'prop-types';
import classNames from 'classnames';

const StatusBanner = ({ icon, title, subtitle, action, children, className, dataTestId = 'status-banner' }) => (
    <div className={classNames('DS__status-banner', className)} data-testid={dataTestId}>
        <div className="DS__status-banner__row">
            <div className="DS__status-banner__main">
                {icon && <span className="DS__status-banner__icon">{icon}</span>}
                <div className="DS__status-banner__text">
                    {title && <div className="DS__status-banner__title">{title}</div>}
                    {subtitle && <div className="DS__status-banner__subtitle">{subtitle}</div>}
                </div>
            </div>
            {action && <div className="DS__status-banner__action">{action}</div>}
        </div>
        {children}
    </div>
);

const Action = ({ onClick, children, dataTestId = 'status-banner-action' }) => (
    <button
        type="button"
        className="DS__status-banner__action-btn"
        onClick={onClick}
        data-testid={dataTestId}
    >
        {children}
    </button>
);

const Note = ({ variant = 'neutral', children, className }) => (
    <div className={classNames('DS__status-banner__note', `DS__status-banner__note--${variant}`, className)}>
        {children}
    </div>
);

const NoteHeading = ({ children }) => (
    <div className="DS__status-banner__note-heading">{children}</div>
);

const NoteBody = ({ children }) => (
    <div className="DS__status-banner__note-body">{children}</div>
);

const NoteMeta = ({ children }) => (
    <div className="DS__status-banner__note-meta">{children}</div>
);

Note.Heading = NoteHeading;
Note.Body = NoteBody;
Note.Meta = NoteMeta;

StatusBanner.Action = Action;
StatusBanner.Note = Note;

StatusBanner.propTypes = {
    icon: PropTypes.node,
    title: PropTypes.node,
    subtitle: PropTypes.node,
    action: PropTypes.node,
    children: PropTypes.node,
    className: PropTypes.string,
    dataTestId: PropTypes.string,
};

Action.propTypes = {
    onClick: PropTypes.func,
    children: PropTypes.node,
    dataTestId: PropTypes.string,
};

Note.propTypes = {
    variant: PropTypes.oneOf(['neutral', 'info', 'error', 'warning', 'success']),
    children: PropTypes.node,
    className: PropTypes.string,
};

NoteHeading.propTypes = { children: PropTypes.node };
NoteBody.propTypes = { children: PropTypes.node };
NoteMeta.propTypes = { children: PropTypes.node };

export default StatusBanner;
